export default __webpack_public_path__ + "static/media/quadra.f2891110.png";